/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchWholeParentCompany/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function SearchWholeParentCompany({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Filters/Content/SearchWholeParentCompany",
  onChange
  
}) {
let searchWholeParentCompanyValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'whole_parent_company',
})
let searchWholeParentCompanyChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'whole_parent_company',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 data="search.whole_parent_company"
 value={searchWholeParentCompanyValueData}
 onChange={searchWholeParentCompanyChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Search across the whole company"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}